import PageHeader from 'components/pageHeader/PageHeader';
import { Trans } from 'react-i18next';
import usePropertySettingsInitData from '../usePropertySettingsInitData';

const PropertySettingsSeasonalityTabHeader = () => {
  const { property, isLoading: isLoadingInitData } =
    usePropertySettingsInitData();
  return (
    <PageHeader
      className="tab-title"
      title={
        <Trans
          i18nKey="pageProperty.seasonality.tabTitle"
          values={{ propertyName: property?.name }}
          components={{ 1: <span className="green" /> }}
        />
      }
      noDivider
      isLoading={isLoadingInitData}
    />
  );
};

export default PropertySettingsSeasonalityTabHeader;
